import API from '@services/API';

const CartaoService = {

  calcularNota: async(processo,obj) => await API.add(`/${processo}/escolas/cartoes/calculaNota`, obj),
  girar: async(cartaoId,qtdRotacoes) => await API.add(`/processo/escolas/cartoes/girar`, {cartaoId:cartaoId,qtdRotacoes:qtdRotacoes}),
  detalhamentoObjetos: async(obj,cartao) => await API.get(`/cartoes/${cartao}/informacoesDeObjetos?objeto=${obj}`),

}

export default CartaoService;
